export interface Article {
  id: string;
  title: string;
  slug: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  imageUrl: string;
  imageAlt: string;
  author: string;
  publishDate: string;
  isHot: boolean;
  isExclusive: boolean;
  tags: string[];
  viewCount: number;
  commentCount: number;
}

export const categories = [
  { name: '全部', slug: 'all', icon: 'ri-global-line' },
  { name: '娱乐圈', slug: 'yulequan', icon: 'ri-movie-2-line' },
  { name: '明星爆料', slug: 'mingxing', icon: 'ri-star-line' },
  { name: '网红黑料', slug: 'wanghong', icon: 'ri-live-line' },
  { name: '独家猛料', slug: 'dujia', icon: 'ri-fire-line' },
  { name: '八卦内幕', slug: 'bagua', icon: 'ri-chat-smile-2-line' },
];

export const articles: Article[] = [
  {
    id: '1',
    title: '某顶流男星深夜私会神秘女子，酒店共度8小时，知情人曝已交往半年',
    slug: 'dingliu-nanxing-sihei-mimi-nvzi',
    excerpt: '据知情人士透露，这位顶流男星与一名非圈内女子已经秘密交往半年，两人于上周五深夜在某五星级酒店被拍到同进同出，引发热议。',
    content: `<p>近日，有网友爆料称在某五星级酒店偶遇一位当红顶流男星与一名神秘女子深夜同行。据目击者描述，两人于当晚11点左右先后进入酒店，直到第二天早上7点才分别离开，共度约8小时。</p>
    <p>知情人透露，这位男星与该女子已经秘密交往半年之久，女方并非娱乐圈人士，而是一位金融行业从业者。两人通过朋友介绍认识，感情稳定。</p>
    <p>该男星的粉丝后援会目前尚未对此事做出回应，但其工作室的社交媒体账号评论区已被粉丝"攻陷"。有粉丝表示"如果是真的就祝福"，也有人质疑爆料的真实性。</p>
    <p>业内人士分析，如果此事属实，对该男星的商业价值可能会产生一定影响，毕竟其定位一直是"单身优质偶像"。</p>
    <p>截至目前，当事人及其团队尚未对此事发表任何官方声明。我们将持续关注事件进展。</p>`,
    category: '娱乐圈',
    categorySlug: 'yulequan',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20moody%20luxury%20hotel%20lobby%20at%20night%20with%20dramatic%20shadows%20and%20warm%20ambient%20lighting%2C%20cinematic%20film%20noir%20aesthetic%2C%20mysterious%20atmosphere%2C%20empty%20corridor%20with%20elegant%20interior%20design%2C%20soft%20focus%20background&width=800&height=500&seq=article-1&orientation=landscape',
    imageAlt: '顶流男星深夜私会神秘女子',
    author: '爆料君',
    publishDate: '2026-08-07',
    isHot: true,
    isExclusive: true,
    tags: ['顶流男星', '恋情曝光', '酒店私会'],
    viewCount: 128900,
    commentCount: 3456,
  },
  {
    id: '2',
    title: '知名网红被曝偷税漏税高达千万，税务机关已介入调查',
    slug: 'zhiming-wanghong-toushui-loushui',
    excerpt: '据可靠消息，某拥有3000万粉丝的头部网红因涉嫌偷逃税款被税务机关立案调查，涉案金额或达数千万元，引发行业震动。',
    content: `<p>近日，有权威消息人士向本平台爆料，某位拥有超过3000万粉丝的头部网红因涉嫌偷逃巨额税款，已被当地税务机关正式立案调查。</p>
    <p>据透露，该网红主要通过直播打赏、品牌代言、电商带货等多种渠道获取收入，年收入据估计超过亿元。然而其在过去三年中，通过设立多家空壳公司、虚假申报等方式，涉嫌偷逃税款累计高达数千万元。</p>
    <p>税务部门在例行稽查中发现了异常数据，经过深入调查后决定立案。目前案件正在进一步侦办中。</p>
    <p>此消息一出，立刻在网红圈引起轩然大波。多位知名网红纷纷自查税务状况，行业内掀起了一股"补税潮"。</p>
    <p>法律专家表示，偷逃税款数额巨大者，除补缴税款和滞纳金外，还可能面临刑事处罚。此前已有先例，某知名主播因偷税被追缴并处罚款共计超过亿元。</p>`,
    category: '网红黑料',
    categorySlug: 'wanghong',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20office%20scene%20with%20papers%20and%20documents%20scattered%20on%20desk%2C%20spotlight%20on%20financial%20documents%2C%20cinematic%20noir%20lighting%20with%20strong%20shadows%2C%20tense%20atmosphere%2C%20moody%20interior&width=800&height=500&seq=article-2&orientation=landscape',
    imageAlt: '网红偷税漏税被调查',
    author: '深度调查组',
    publishDate: '2026-08-06',
    isHot: true,
    isExclusive: true,
    tags: ['网红', '偷税漏税', '税务调查'],
    viewCount: 235600,
    commentCount: 7823,
  },
  {
    id: '3',
    title: '某女星与前夫离婚内幕曝光：第三者插足还是利益纠纷？',
    slug: 'nvxing-qianfu-lihun-neimu',
    excerpt: '娱乐圈又一对模范夫妻宣告离婚，多方消息源证实离婚背后涉及复杂的利益纠纷和第三者问题，内幕令人震惊。',
    content: `<p>近日，娱乐圈一对被外界视为"模范夫妻"的明星夫妇突然宣布离婚，令众多粉丝唏嘘不已。然而，据多方消息源透露，这场离婚背后远不止表面那么简单。</p>
    <p>知情人A透露，两人早在一年前就已经分居，原因是一方在拍摄某部电视剧时与同组演员产生了超越合作关系的情感。这一情况被另一方发现后，夫妻关系急转直下。</p>
    <p>知情人B则表示，除了感情问题外，两人在财产分割上也存在严重分歧。据悉，两人名下共有超过5亿元的资产，包括多处房产、公司股权以及各种投资收益，财产分割谈判已经持续了数月。</p>
    <p>更令人意外的是，有消息称双方的经纪团队也深度参与了离婚谈判，因为两人的"夫妻档"商业代言合同涉及巨额违约金问题。</p>
    <p>目前，双方的律师团队正在就子女抚养权和财产分割进行最后的博弈。这场离婚大戏，恐怕还将持续相当长的时间。</p>`,
    category: '明星爆料',
    categorySlug: 'mingxing',
    imageUrl: 'https://readdy.ai/api/search-image?query=Broken%20wedding%20ring%20on%20dark%20surface%20with%20dramatic%20spotlight%2C%20cinematic%20noir%20photography%2C%20deep%20shadows%20and%20golden%20highlights%2C%20emotional%20moody%20atmosphere%2C%20minimalist%20composition&width=800&height=500&seq=article-3&orientation=landscape',
    imageAlt: '女星离婚内幕曝光',
    author: '八卦侦探',
    publishDate: '2026-08-05',
    isHot: true,
    isExclusive: false,
    tags: ['女星', '离婚', '内幕', '财产分割'],
    viewCount: 189200,
    commentCount: 5641,
  },
  {
    id: '4',
    title: '某选秀节目黑幕揭秘：导师内定冠军，投票数据造假实锤',
    slug: 'xuanxiu-jiemu-heimu-jieshe',
    excerpt: '前工作人员实名爆料某热门选秀节目存在严重黑幕，包括导师内定冠军、投票数据造假、选手背景不实等问题。',
    content: `<p>一位自称曾在某热门选秀节目担任幕后工作人员的网友，近日在社交平台发布长文，实名揭露该节目的种种黑幕操作，引发广泛关注。</p>
    <p>据该爆料人透露，节目组在录制前就已经确定了最终的前三名选手，所谓的"观众投票"实际上只是走个过场。投票数据由专门的团队进行操控，确保最终结果与预定方案一致。</p>
    <p>更令人震惊的是，部分选手的"素人"背景也被指造假。有选手声称自己是普通大学生，实际上已经是签约练习生多年；有选手的"励志故事"也经过了精心包装和虚构。</p>
    <p>该爆料人还提到，导师们的点评和打分也受到节目组的干预，如果导师不按照节目组的意思打分，可能会面临合约问题。</p>
    <p>此文发布后，迅速在网络上引发热议。节目组官方账号目前处于沉默状态，未做出任何回应。多位业内人士表示，选秀节目的"剧本化"操作早已是公开的秘密，但如此详实的实锤爆料仍然罕见。</p>`,
    category: '八卦内幕',
    categorySlug: 'bagua',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20stage%20with%20spotlight%20and%20empty%20audience%20seats%2C%20backstage%20view%20of%20talent%20show%20set%2C%20dramatic%20theater%20lighting%2C%20cinematic%20noir%20aesthetic%2C%20mysterious%20atmosphere%2C%20shadows%20and%20silhouettes&width=800&height=500&seq=article-4&orientation=landscape',
    imageAlt: '选秀节目黑幕揭秘',
    author: '前业内人士',
    publishDate: '2026-08-04',
    isHot: false,
    isExclusive: true,
    tags: ['选秀节目', '黑幕', '投票造假', '实名爆料'],
    viewCount: 312400,
    commentCount: 12045,
  },
  {
    id: '5',
    title: '知名导演潜规则女演员录音曝光，多位女星卷入风波',
    slug: 'zhiming-daoyan-qian-guize-luyin',
    excerpt: '一段据称是某知名导演与经纪人的通话录音在网络流传，内容涉及利用角色资源进行潜规则交易，多位女演员被点名。',
    content: `<p>今日，一段据称是某知名大导演与某经纪公司负责人的通话录音在网络上疯传，录音内容涉及利用电影角色资源进行不正当交易，引发轩然大波。</p>
    <p>在这段长达15分钟的录音中，可以听到该导演明确表示某部即将开拍的大制作电影的女主角人选"需要好好谈"，并暗示需要通过"特殊方式"来争取角色。录音中还点名提到了多位当红女演员。</p>
    <p>录音曝光后，相关话题迅速登上热搜榜首位。被点名的女演员中，有人第一时间发布声明否认与导演有任何不正当关系，有人则选择保持沉默。</p>
    <p>电影行业协会对此事表示"高度关注"，并呼吁业内人士共同维护行业风气。法律界人士指出，如果录音内容属实，该导演可能面临严重的法律和职业道德问题。</p>
    <p>值得关注的是，这已不是该导演第一次陷入类似争议。三年前就曾有匿名人士爆料其存在"潜规则"行为，但当时因缺乏实锤证据而不了了之。</p>`,
    category: '娱乐圈',
    categorySlug: 'yulequan',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20film%20set%20with%20director%20chair%20silhouette%20under%20dramatic%20spotlight%2C%20empty%20movie%20studio%20at%20night%2C%20cinematic%20noir%20aesthetic%2C%20strong%20shadows%2C%20mysterious%20atmosphere%2C%20film%20equipment%20in%20darkness&width=800&height=500&seq=article-5&orientation=landscape',
    imageAlt: '知名导演潜规则录音曝光',
    author: '独家调查',
    publishDate: '2026-08-03',
    isHot: true,
    isExclusive: true,
    tags: ['导演', '潜规则', '录音曝光', '女演员'],
    viewCount: 456700,
    commentCount: 15678,
  },
  {
    id: '6',
    title: '某带货主播虚假宣传被罚款500万，直播间商品质量堪忧',
    slug: 'daihuo-zhubo-xujia-xuanchuan-fakuan',
    excerpt: '市场监管部门对某知名带货主播开出500万元罚单，因其直播间销售的保健品存在严重虚假宣传，商品质量与宣传严重不符。',
    content: `<p>今日，某市市场监督管理局发布行政处罚决定书，对某拥有2000万粉丝的带货主播处以500万元罚款，原因是其直播间销售的保健品存在严重虚假宣传行为。</p>
    <p>经查，该主播在直播中宣称其销售的某品牌保健品具有"治疗失眠""改善记忆力""增强免疫力"等功效，但实际上该产品仅为普通食品，根本不具备其所宣称的保健和治疗功能。</p>
    <p>更令人愤怒的是，该主播还邀请了所谓的"医学专家"在直播间站台，为产品背书。经核实，这位"专家"的身份同样存在造假嫌疑。</p>
    <p>市场监管部门表示，这是今年以来针对直播带货领域开出的最大一笔罚单。该主播的所有社交媒体账号目前已被平台限制功能。</p>
    <p>此事件再次引发公众对直播带货行业监管的关注。消费者权益保护组织呼吁，应加强对直播带货的全链条监管，建立更严格的准入和退出机制。</p>`,
    category: '网红黑料',
    categorySlug: 'wanghong',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20studio%20with%20empty%20livestream%20setup%2C%20ring%20light%20glowing%20in%20darkness%2C%20products%20scattered%20on%20table%2C%20dramatic%20lighting%2C%20cinematic%20noir%20aesthetic%2C%20eerie%20atmosphere%2C%20modern%20streaming%20equipment&width=800&height=500&seq=article-6&orientation=landscape',
    imageAlt: '带货主播虚假宣传被罚',
    author: '消费观察',
    publishDate: '2026-08-02',
    isHot: false,
    isExclusive: false,
    tags: ['直播带货', '虚假宣传', '罚款', '保健品'],
    viewCount: 98200,
    commentCount: 3245,
  },
  {
    id: '7',
    title: '某男团成员被曝与粉丝私联，聊天记录暧昧露骨',
    slug: 'nantuan-chengyuan-silian-fensi',
    excerpt: '一组据称是某当红男团成员与多名粉丝的私密聊天记录被曝光，内容暧昧露骨，涉及金钱往来和私下约会。',
    content: `<p>近日，一组据称是某当红男团成员与多名粉丝的私密聊天记录在网络上被曝光，内容包含大量暧昧对话和金钱往来细节，令人大跌眼镜。</p>
    <p>曝光的聊天记录显示，该成员主动添加了多位粉丝的私人联系方式，并在聊天中频繁使用暧昧语言。更令人震惊的是，聊天记录中还存在向粉丝索要礼物的内容，包括名牌包、高端电子产品等。</p>
    <p>此外，该成员还被指多次与粉丝私下见面。据一位自称当事粉丝的用户透露，该成员曾以"签售会补签"为由约其单独见面，地点在某私人住宅。</p>
    <p>该男团的经纪公司目前尚未对此事发表声明。但粉丝内部已经出现了严重分裂，一部分粉丝选择相信偶像，另一部分则感到"被背叛"。</p>
    <p>娱乐法律师表示，偶像与粉丝之间存在"不对等关系"，偶像利用这种关系谋取私利的行为，虽然可能不构成法律问题，但严重违反了职业道德。</p>`,
    category: '明星爆料',
    categorySlug: 'mingxing',
    imageUrl: 'https://readdy.ai/api/search-image?query=Smartphone%20screen%20glowing%20in%20darkness%20with%20chat%20messages%20silhouette%2C%20dramatic%20noir%20lighting%2C%20mysterious%20atmosphere%2C%20bedroom%20at%20night%2C%20cinematic%20composition%2C%20dark%20moody%20tones&width=800&height=500&seq=article-7&orientation=landscape',
    imageAlt: '男团成员私联粉丝',
    author: '饭圈观察员',
    publishDate: '2026-08-01',
    isHot: true,
    isExclusive: false,
    tags: ['男团', '私联粉丝', '聊天记录', '偶像失格'],
    viewCount: 287300,
    commentCount: 9876,
  },
  {
    id: '8',
    title: '独家：某影视公司老板涉嫌洗钱被带走调查，旗下艺人纷纷解约',
    slug: 'yingshi-gongsi-laoban-xiqian',
    excerpt: '独家消息：某知名影视公司实际控制人因涉嫌洗钱已被警方带走协助调查，公司旗下多名艺人紧急启动解约程序。',
    content: `<p>本平台独家获悉，某知名影视公司的实际控制人王某于昨日被警方从家中带走，目前正在接受调查。据悉，王某涉嫌通过影视投资项目进行洗钱活动，涉案金额可能高达数十亿元。</p>
    <p>据知情人士透露，王某通过虚高影视制作成本、虚构海外投资项目等方式，将非法资金"洗白"为合法收入。这一操作模式已经持续了至少五年，涉及多个大型影视项目。</p>
    <p>消息传出后，该公司旗下多名签约艺人紧急联系律师，启动解约程序。一位不愿透露姓名的艺人经纪人表示："谁也不愿意跟一个有法律风险的公司绑在一起。"</p>
    <p>该公司出品的多部电视剧和电影目前也受到影响，多个项目已经暂停拍摄或后期制作。投资方纷纷撤资，公司面临前所未有的危机。</p>
    <p>行业分析师指出，此事件可能引发影视行业的新一轮整顿，相关部门可能会加强对影视投资的资金来源审查。</p>`,
    category: '独家猛料',
    categorySlug: 'dujia',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20office%20building%20at%20night%20with%20police%20car%20lights%20reflecting%2C%20dramatic%20cinematic%20noir%20scene%2C%20corporate%20headquarters%20silhouette%2C%20ominous%20atmosphere%2C%20blue%20and%20red%20emergency%20lights%20in%20darkness&width=800&height=500&seq=article-8&orientation=landscape',
    imageAlt: '影视公司老板被带走调查',
    author: '独家爆料组',
    publishDate: '2026-07-31',
    isHot: true,
    isExclusive: true,
    tags: ['影视公司', '洗钱', '独家爆料', '艺人解约'],
    viewCount: 398500,
    commentCount: 13452,
  },
  {
    id: '9',
    title: '某综艺节目录制现场发生冲突，两位嘉宾大打出手',
    slug: 'zongyi-jiemu-chongtu-dachu-shou',
    excerpt: '据现场工作人员爆料，某热门综艺节目在最新一期录制过程中，两位嘉宾因意见不合爆发激烈冲突，场面一度失控。',
    content: `<p>据一位自称在某综艺节目担任现场工作人员的用户爆料，该节目在最新一期的录制过程中发生了严重的冲突事件。</p>
    <p>据描述，冲突的起因是两位嘉宾在游戏环节中对规则的理解产生了分歧。其中一位嘉宾认为对方"故意耍赖"，当场发飙，摔了手中的道具。另一位嘉宾不甘示弱，上前推搡，双方随后扭打在一起。</p>
    <p>现场工作人员紧急上前拉开两人，录制被迫中断了近两个小时。节目导演和制片人分别与两位嘉宾进行了长时间的沟通，最终才使得录制得以继续。</p>
    <p>但据现场目击者称，两位嘉宾在后面的录制环节全程零互动，气氛异常尴尬。节目组可能面临大量后期剪辑工作来掩盖这一尴尬局面。</p>
    <p>此事在社交媒体上已经引发广泛讨论，#综艺录制现场打架#的话题阅读量已突破2亿。网友们纷纷猜测这两位嘉宾的身份，多个名字轮番登上热搜。</p>`,
    category: '八卦内幕',
    categorySlug: 'bagua',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20TV%20studio%20with%20overturned%20chairs%20and%20scattered%20props%2C%20dramatic%20spotlight%2C%20chaotic%20scene%20after%20conflict%2C%20cinematic%20noir%20aesthetic%2C%20tense%20atmosphere%2C%20empty%20stage%20with%20debris&width=800&height=500&seq=article-9&orientation=landscape',
    imageAlt: '综艺节目录制现场冲突',
    author: '现场直击',
    publishDate: '2026-07-30',
    isHot: false,
    isExclusive: false,
    tags: ['综艺节目', '冲突', '录制事故', '打架'],
    viewCount: 187600,
    commentCount: 6543,
  },
  {
    id: '10',
    title: '揭秘某顶流女星幕后团队运作模式：数据造假、控评、营销一条龙',
    slug: 'jiemi-dingliu-nvxing-tuandui-yunzuo',
    excerpt: '深度调查揭示了某顶流女星背后团队的完整运作体系，包括数据造假、全网控评、话题营销等一系列操作手法。',
    content: `<p>经过长达三个月的深入调查，本平台今日独家揭秘某顶流女星幕后团队的完整运作模式，揭露了娱乐圈"造星"背后的真实面貌。</p>
    <p>据调查，该女星的团队包括一支超过50人的专业运营团队，分为数据组、舆情组、营销组和法务组四个部门。每个部门各司其职，形成了完整的"造星"产业链。</p>
    <p>数据组负责在各大平台进行数据造假，包括微博粉丝数、话题阅读量、超话排名等，通过购买"水军"和自动化工具来实现。据估算，该女星每年在数据维护上的花费超过千万元。</p>
    <p>舆情组则负责全网"控评"——正面内容大力推广，负面内容迅速压制。他们与多个营销号、论坛版主、平台审核人员建立了密切关系，确保任何不利信息都能在第一时间被处理。</p>
    <p>营销组负责策划各种热搜话题和"碰瓷"营销，通过精心设计的事件来维持曝光度。从"机场穿搭"到"公益慈善"，每一个热搜背后都有团队的精心策划。</p>`,
    category: '八卦内幕',
    categorySlug: 'bagua',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20control%20room%20with%20multiple%20monitors%20displaying%20social%20media%20dashboards%2C%20silhouette%20of%20people%20working%2C%20cinematic%20noir%20lighting%2C%20tech%20surveillance%20aesthetic%2C%20dramatic%20atmosphere%2C%20blue%20screen%20glow&width=800&height=500&seq=article-10&orientation=landscape',
    imageAlt: '顶流女星团队运作揭秘',
    author: '深度调查组',
    publishDate: '2026-07-29',
    isHot: false,
    isExclusive: true,
    tags: ['顶流女星', '数据造假', '团队运作', '深度调查'],
    viewCount: 345200,
    commentCount: 11234,
  },
  {
    id: '11',
    title: '某知名歌手演唱会假唱被实锤，粉丝退款呼声高涨',
    slug: 'zhiming-geshou-jiachang-shichui',
    excerpt: '技术分析人士通过音频比对证实某知名歌手在近期演唱会中存在大量假唱段落，引发粉丝强烈不满和退票呼声。',
    content: `<p>近日，一位音乐技术分析博主发布了一段详细的音频分析视频，通过专业软件对某知名歌手近期演唱会现场录音进行逐句分析，证实了其存在大量假唱行为。</p>
    <p>分析显示，该歌手在整场演唱会中有超过60%的歌曲使用了预录音轨，即所谓的"半开麦"甚至"全闭麦"。只有在与观众互动的闲聊环节，才能听到其真实的嗓音状态。</p>
    <p>视频发布后，在网络上引起轩然大波。购买了演唱会门票的粉丝们纷纷表达了强烈不满，认为被欺骗。有粉丝在社交平台发起"假唱退票"话题，呼吁相关部门介入调查。</p>
    <p>根据《营业性演出管理条例》，演员在演出中应当保证表演质量，不得有欺骗观众的行为。法律人士指出，如果有充分证据证明假唱行为，消费者有权要求退还票款。</p>
    <p>该歌手的经纪公司尚未对此事做出回应。但其即将在多个城市举办的巡回演唱会门票销售已经受到了明显影响，多个场次出现大量退票。</p>`,
    category: '明星爆料',
    categorySlug: 'mingxing',
    imageUrl: 'https://readdy.ai/api/search-image?query=Empty%20concert%20stage%20with%20microphone%20stand%20under%20dramatic%20spotlight%2C%20dark%20arena%2C%20cinematic%20noir%20photography%2C%20lonely%20atmosphere%2C%20abandoned%20performance%20setting%2C%20moody%20shadows&width=800&height=500&seq=article-11&orientation=landscape',
    imageAlt: '歌手演唱会假唱实锤',
    author: '音乐观察',
    publishDate: '2026-07-28',
    isHot: false,
    isExclusive: false,
    tags: ['假唱', '演唱会', '歌手', '退票'],
    viewCount: 167800,
    commentCount: 5432,
  },
  {
    id: '12',
    title: '独家：某国际品牌代言人私下吐槽产品，品牌方紧急撤换代言',
    slug: 'guoji-pinpai-daiyanren-tucao',
    excerpt: '独家消息：某国际知名品牌的中国区代言人被曝在私人聚会中公开吐槽代言产品质量差，品牌方得知后紧急启动代言更换程序。',
    content: `<p>本平台独家获悉，某国际知名护肤品牌的中国区代言人近日因在私人聚会上公开吐槽代言产品质量而陷入代言危机。</p>
    <p>据在场人士透露，该代言人在一场私人聚会上被朋友问及代言的某款面霜效果如何时，直言"我自己根本不用，那个成分表一看就不行，都是营销包装出来的"。这番言论被在场人士录音并流传出去。</p>
    <p>品牌方得知此事后勃然大怒，连夜召开紧急会议，决定立即启动代言人更换程序。品牌中国区市场总监在内部邮件中表示："这种行为是对品牌和消费者的极大不尊重。"</p>
    <p>根据代言合同条款，代言人不得公开发表任何有损品牌形象的言论，违反者将面临巨额违约金赔偿。据业内人士估算，该代言人的违约赔偿可能高达代言费的3-5倍。</p>
    <p>截至目前，该代言人和品牌方均未公开发表声明。但品牌官网和电商平台上的相关宣传物料已经开始陆续下架。</p>`,
    category: '独家猛料',
    categorySlug: 'dujia',
    imageUrl: 'https://readdy.ai/api/search-image?query=Luxury%20skincare%20products%20scattered%20on%20dark%20marble%20surface%20with%20dramatic%20spotlight%2C%20broken%20mirror%20reflection%2C%20cinematic%20noir%20aesthetic%2C%20elegant%20but%20ominous%20atmosphere%2C%20dark%20moody%20tones&width=800&height=500&seq=article-12&orientation=landscape',
    imageAlt: '品牌代言人吐槽产品',
    author: '独家爆料组',
    publishDate: '2026-07-27',
    isHot: false,
    isExclusive: true,
    tags: ['品牌代言', '独家爆料', '代言危机', '违约金'],
    viewCount: 213400,
    commentCount: 7654,
  },
];